import { startOfHour, addHours } from 'date-fns'

export function startOfNextHour(timestamp) {
  return addHours(startOfHour(new Date(timestamp)), 1).getTime()
}

function isStartOfHour(date) {
  return date.getMinutes() + date.getSeconds() + date.getMilliseconds() === 0
}

/**
 * When used as a controlled component, onChange will output timestamps for start and end
 * at :00 (top of the hour). When given a value that does not have minutes === 0 (e.g. a default
 * value not set by onChange), return the start of the next hour. Otherwise, returns the original
 * value.
 * @param timestamp
 * @returns {number}
 */
export function topOfHour(timestamp) {
  const date = new Date(timestamp)
  return isStartOfHour(date) ? timestamp : startOfNextHour(timestamp)
}
